export default __webpack_public_path__ + "static/GaryCobain-f12b9ac2faa5e30d36ba520ee9345188.jpeg";